<script setup>
import {Prices} from "@/main/prices";

const versions = Prices.versions.map((version) => {
  const features = {};

  version.features.forEach((feature) => {
    if ( feature.checked ) {
      features[feature.name] = feature;
    }
  })
  return {...version, features}
});
const features = Prices.features;
</script>

<template>
<div>
  <header class="page-head">
    <div class="wrap">
      <span class="badge">版本与定价</span>
      <h1>个人版 / 机构版：按使用场景选择</h1>
      <p>下述为官网展示用的版本结构示例。你可以在上线前把价格与权益改成你们最终确认的版本表述。</p>
    </div>
  </header>

  <section class="section">
    <div class="wrap">
      <div class="split">
        <div class="panel">
          <h3>个人版（邮箱注册）</h3>
          <p>适合学生、研究者与个人用户：快速上手文献深度阅读与长期积累。</p>
          <ul class="list">
            <li><span class="high">PDF 导读永久免费</span>（基础能力）</li>
            <li>支持多源文献：PDF / Word / 搜索结果</li>
            <li>可视化导读 + 证据溯源</li>
            <li>可配置多模型 AI（按需使用）</li>
          </ul>
          <div style="margin-top:14px" class="btn-group">
            <router-link to="/download" class="btn primary">
              去下载
            </router-link>
            <router-link to="/faq" class="btn">查看 FAQ</router-link>
          </div>
        </div>

        <div class="panel">
          <h3>机构版（申请试用）</h3>
          <p>适合高校、医院、科研院所与图书馆信息服务：激活机构文献资源与科研服务能力。</p>
          <ul class="list">
            <li>机构授权与统一管理</li>
            <li>可选专属部署与定制模块</li>
            <li>适配内网 / 私有文献与合规要求</li>
            <li>支持培训、交付与技术支持</li>
          </ul>
          <div style="margin-top:14px" class="btn-group">
            <router-link class="btn primary" to="/trial">申请试用</router-link>
            <router-link class="btn" to="/features">查看功能</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section">
    <div class="wrap">
      <h2>版本对比（示例）</h2>
      <p class="lead">下面表格是静态站点的展示样式占位，你可以按最终业务策略调整字段。</p>

      <table class="table" aria-label="版本对比表">
        <thead>
        <tr>
          <th>能力</th>
          <th v-for="version in versions" class="col-edition">
            {{version.name}}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="feature in features">
          <td>{{feature}}</td>
          <td v-for="version in versions" class="col-edition">
          <span class="check" v-if="version.features.hasOwnProperty(feature)">
            ✓
          </span>
            <span class="cross" v-else>
            ✕
          </span>
          </td>
          <!--        <td class="cross">✕</td>
                  <td class="check">✓</td>-->
        </tr>
        </tbody>
      </table>

      <div style="margin-top:18px" class="cta">
        <div>
          <h2>准备开始？</h2>
          <p>个人用户：邮箱注册即可使用；机构用户：扫码申请试用，获取部署与定制方案。</p>
        </div>
        <div style="display:flex; gap:10px; flex-wrap:wrap" class="btn-group">
          <router-link class="btn primary" to="/download">个人版下载</router-link>
          <router-link class="btn" to="/trial">申请机构试用</router-link>
        </div>
      </div>
    </div>
  </section>
</div>
</template>
